import * as React from 'react';
import { ConditionalRenderer } from 'Components/ConditionalRenderer';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { useFeatureCanary } from 'utils/useFeatureCanary';
import { ApplicationContainer, StyledApplication } from './styled';

export const Application: React.SFC = props => {
	const isOffWhiteBackground = useFeatureCanary(FeatureFlag.EnableOffWhiteBackground);
	const isCenterAlignClassicViewEnabled = useFeatureCanary(
		FeatureFlag.CenterAlignClassicView
	);
	return (
		<StyledApplication
			isOffWhiteBackground={isOffWhiteBackground}
			isClassicView={isCenterAlignClassicViewEnabled}
		>
			<ConditionalRenderer
				flag={isCenterAlignClassicViewEnabled}
				OnComponent={ApplicationContainer}
			>
				{props.children}
			</ConditionalRenderer>
		</StyledApplication>
	);
};
